import { getAudioParamRenderer } from '../helpers/get-audio-param-renderer';
import { renderInputsOfAudioParam } from '../helpers/render-inputs-of-audio-param';
export const renderAutomation = (context, nativeOfflineAudioContext, audioParam, nativeAudioParam) => {
    const audioParamRenderer = getAudioParamRenderer(context, audioParam);
    audioParamRenderer.replay(nativeAudioParam);
    return renderInputsOfAudioParam(context, audioParam, nativeOfflineAudioContext, nativeAudioParam);
};
//# sourceMappingURL=/build/es2018/helpers/render-automation.js.map